import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

export function Field({ label, required, error, children, className }) {
  return (
    <div className={cn("space-y-1.5", className)}>
      {label && (
        <Label className="text-xs font-medium text-ink-2">
          {label} {required && <span className="text-danger">*</span>}
        </Label>
      )}
      {children}
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  );
}

export function TextField({ label, required, error, value, onChange, placeholder, type = "text", testid }) {
  return (
    <Field label={label} required={required} error={error}>
      <Input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testid}
        className={error ? "border-danger" : ""}
      />
    </Field>
  );
}

export function AreaField({ label, value, onChange, placeholder, rows = 3, testid }) {
  return (
    <Field label={label}>
      <Textarea value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} rows={rows} data-testid={testid} />
    </Field>
  );
}

export function SelectField({ label, required, error, value, onChange, options, placeholder = "Select…", testid }) {
  return (
    <Field label={label} required={required} error={error}>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testid} className={error ? "border-danger" : ""}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => {
            const val = typeof o === "string" ? o : o.value;
            const lbl = typeof o === "string" ? o : o.label;
            return (
              <SelectItem key={val} value={val}>{lbl}</SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </Field>
  );
}
